import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirCategory } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirCategoriesAdapter = createEntityAdapter<JSONApiDataObject<BsdirCategory>>({
  selectId: item => item.id
});

export const bsdirCategoriesSlice = createSlice({
  name: 'bsdirCategories',
  initialState: bsdirCategoriesAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirCategory>),
  reducers: {
    bsdirCategoriesAdded: (state, action) => {
      bsdirCategoriesAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirCategoriesSelectors = bsdirCategoriesAdapter.getSelectors(
  (state: RootState) => state.bsdir.categories);
export default bsdirCategoriesSlice.reducer;
